import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Parsers, Formatters, Validators } from '@honeycomb-npm/honeycomb';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { TextInputHelper } from './TextInputHelper.js';

var _excluded = ["errormessage", "errormessageMin", "errormessageMax", "min", "max", "precision"];
/* eslint-disable @typescript-eslint/no-explicit-any */
var TextInputHelperCurrency = props => {
  var {
      errormessage,
      errormessageMin,
      errormessageMax,
      min,
      max,
      precision
      // eslint-disable-line
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  attributes.parser = value => Parsers.parseNumber(value, precision);
  attributes.formatter = value => Formatters.formatCurrency(value);
  var validators = [];
  if (props.required) {
    validators.push({
      errormessage: errormessage || 'Enter an amount.',
      method: value => Validators.minLength(value, 1)
    });
  }
  if (typeof props.min !== 'undefined') {
    var errormessagemin = errormessageMin || "That's less than the minimum amount of ".concat(Formatters.formatCurrency(min), ". Enter a higher amount.");
    validators.push({
      errormessage: errormessagemin,
      method: value => {
        if (value === '' && props.required === false) {
          return true;
        }
        return Validators.minValue(value, min);
      }
    });
  }
  if (typeof props.max !== 'undefined') {
    var errormessagemax = errormessageMax || "That's more than the maximum amount of ".concat(Formatters.formatCurrency(max), ". Enter a lower amount.");
    validators.push({
      errormessage: errormessagemax,
      method: value => {
        if (value === '' && props.required === false) {
          return true;
        }
        return Validators.maxValue(value, max);
      }
    });
  }
  if (validators.length > 0) {
    attributes.validators = validators;
  }
  return /*#__PURE__*/React.createElement(TextInputHelper, attributes);
};
TextInputHelperCurrency.defaultProps = {
  required: false
};
TextInputHelperCurrency.propTypes = {
  errormessage: PropTypes.string,
  helptext: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  precision: PropTypes.number,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export { TextInputHelperCurrency };
